module.exports = __webpack_public_path__ + "img/teams-no-node-selected.b4842846.svg";